// material-ui
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export default DrawerHeaderStyled;
